import { gql } from '@apollo/client';

const Fragments = {
  verificationTypeListItem: gql`
    fragment verificationTypeListItem on VerificationType {
      verificationTypeId
      verificationName
      kindOfVerificationId
      kindOfVerification
      isActive
    }
  `
};

export default Fragments;
